import type { Observable } from 'rxjs';

import apiService from '../api';
import type { ApiService } from '../api';
import type { IChargebackApi } from './types';

class BetaApi implements IChargebackApi {
  constructor(private apiService: ApiService) {}

  public uploadChargebackFile(file: File, invoiceId: number): Promise<void> {
    const formData = new FormData();
    formData.append('invoice_id', invoiceId.toString());

    formData.append('files[]', file);

    return this.apiService.post(`/reports/chargebacks/${invoiceId}/new/files`, formData).toPromise();
  }
  public loadChargebacksFiles(invoiceId: number): Observable<any> {
    return this.apiService.get(`/reports/chargebacks/${invoiceId}/new/files`, {});
  }
  public removeChargebackFile(invoiceId: number, fileId: number): Observable<void> {
    return this.apiService.delete(`/reports/chargebacks/${invoiceId}/new/files/${fileId}`);
  }
}
const betaApi = new BetaApi(apiService);
export default betaApi;
